import React from 'react';
import { Download } from '@mui/icons-material';

export const DownloadContractOptions = {
  DOWNLOAD_ACTIVE_CONTRACTS: 'DOWNLOAD_ACTIVE_CONTRACTS',
  DOWNLOAD_AUTOMATIC_BILLING_DEACTIVATED_CONTRACTS:
    'DOWNLOAD_AUTOMATIC_BILLING_DEACTIVATED_CONTRACTS'
};

export const DownloadContractMenuOptions = [
  {
    label: 'COMMON.DOWNLOAD_ACTIVE_CONTRACTS',
    key: DownloadContractOptions.DOWNLOAD_ACTIVE_CONTRACTS,
    icon: <Download />
  },
  {
    label: 'COMMON.DOWNLOAD_AUTOMATIC_BILLING_DEACTIVATED_CONTRACTS',
    key:
      DownloadContractOptions.DOWNLOAD_AUTOMATIC_BILLING_DEACTIVATED_CONTRACTS,
    icon: <Download />
  }
];

export const selectDownloadContractOptions = () => {
  const actions = DownloadContractMenuOptions.filter(item => {
    return [
      DownloadContractOptions.DOWNLOAD_ACTIVE_CONTRACTS,
      DownloadContractOptions.DOWNLOAD_AUTOMATIC_BILLING_DEACTIVATED_CONTRACTS
    ].includes(item.key);
  });
  return actions;
};
